import { getValueByUrlKey } from "../utils/get-value-by-url-key";
const ecid = [
    {
        id: "ecid-1",
        src: "images/virtual-background/background-8.jpg",
        tooltip: "ecid1",
    },
    {
        id: "ecid-2",
        src: "https://i.imgur.com/49UveZf.jpeg",
        tooltip: "ecid2",
    },
];
const operative = [
    {
        id: "operative-1",
        src: "images/virtual-background/background-9.jpg",
        tooltip: "operative1",
    },
];
const medvar = [
    {
        id: "medvar-1",
        src: "images/virtual-background/background-1.jpg",
        tooltip: "medvar1",
    },
];
const mentor = [
    {
        id: "mentor-1",
        src: "images/virtual-background/background-8.jpg",
        tooltip: "mentor1",
    },
    {
        id: "mentor-2",
        src: "https://i.imgur.com/49UveZf.jpeg",
        tooltip: "mentor2",
    },
];
const virtualBGMap = {
    "meet.ecid": ecid,
    operative,
    "meet.medvar": medvar,
    "meet.mentor": mentor,
};
export function getVirtualBackgrounds() {
    return getValueByUrlKey(["meet.ecid", "meet.medvar", "meet.mentor", "operative"], virtualBGMap) ?? operative;
}
